export const getUrl = (url: string) => {
  if (url.match(/https?:/gi)) {
    return url
  } else {
    return `http://${url}`
  }
}
